import * as React from "react";
import { Icon, ClipboardButton } from "components/common";
import ErrorPage from "components/errors/ErrorPage";
import withLocation from "routing/withLocation";
const createErrorMessageString = (errorDetails, pageDetails, errorMessage) => {
  const defaultText = `${pageDetails}
${errorMessage}`;
  if (errorDetails) {
    return `${errorDetails}
${defaultText}`;
  }
  return defaultText;
};
const UnauthorizedErrorPage = ({
  error,
  errorDetails = void 0,
  title = "Missing Permissions",
  description = void 0,
  location: { pathname }
}) => {
  var _a;
  const errorMessage = (_a = error == null ? void 0 : error.message) != null ? _a : JSON.stringify(error);
  const pageDetails = `The permissions check for the following request failed,
while trying to access ${pathname}.`;
  const defaultDescription = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "You do not have the required permissions to view this resource."), /* @__PURE__ */ React.createElement("p", null, "Please contact your administrator and provide the error details."));
  const errorMessageString = createErrorMessageString(errorDetails, pageDetails, errorMessage);
  return /* @__PURE__ */ React.createElement(ErrorPage, { title, description: description != null ? description : defaultDescription }, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("pre", { className: "content" }, /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(
    ClipboardButton,
    {
      title: /* @__PURE__ */ React.createElement(Icon, { name: "content_copy" }),
      bsSize: "sm",
      text: errorMessageString,
      buttonTitle: "Copy error details to clipboard"
    }
  )), errorDetails && /* @__PURE__ */ React.createElement("p", null, errorDetails), /* @__PURE__ */ React.createElement("p", null, pageDetails), /* @__PURE__ */ React.createElement("p", null, errorMessage)))));
};
export default withLocation(UnauthorizedErrorPage);
